import type { BoundedTextElement } from '@/typings/customilyElements/canvasElements';
import type { CanvasEx } from '@/typings/canvas';

export interface PatternTextService {
    buildPatternReplica: (
        canvas: CanvasEx,
        origin: PatternElement,
        cell: PatternCell,
        options: { uuid?: string; left: number; top: number; zIndex?: number; editMode?: boolean }
    ) => PatternElement;
    repositionPatternReplica: (
        origin: PatternElement,
        replica: PatternElement,
        position: { left: number; top: number },
        resize: boolean
    ) => void;
    syncPatternReplica: (
        canvas: CanvasEx,
        origin: PatternElement,
        replica: PatternElement,
        position: { left: number; top: number }
    ) => Promise<void>;
    getPatternReplicaObjects: (canvas: CanvasEx, originUuid: string) => PatternElement[];
}

export interface PatternProductService {
    addPatternElementsLink: (originUuid: string, replicaUuid: string) => void;
    removePatternElementsLinks: (originUuid: string) => void;
    removePatternElementsLinkByReplica: (replicaUuid: string) => void;
}

export interface CreateTextPatternHandlersParams {
    getCanvas: () => CanvasEx;
    $scope: { editMode?: boolean };
    TextService: PatternTextService;
    ProductService: PatternProductService;
}

export interface PatternElement extends BoundedTextElement {
    pattern?: boolean;
    patternConfig?: PatternConfig | null;
    isPatternReplica?: boolean;
    patternOriginUuid?: string;
    patternCell?: PatternCell;
}

export interface PatternConfig {
    spacingX: number;
    spacingY: number;
    offsetX: number;
    offsetY: number;
    rows: number;
    cols: number;
}

export const PATTERN_DEFAULTS: PatternConfig = {
    spacingX: 0,
    spacingY: 0,
    offsetX: 0,
    offsetY: 0,
    rows: 1,
    cols: 1
};

export interface PatternCell {
    row: number;
    col: number;
}

export interface CellPosition extends PatternCell {
    left: number;
    top: number;
}
